import React from "react";
import "./PopularVacancies.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import SwiperCore, { Navigation } from "swiper";

SwiperCore.use(Navigation);

function PopularVacancies(props) {
  const { vacancies } = props;

  return (
    <div className="PopularVacancies">
      <div className="PopularVacancies-button-prev"></div>
      <div className="PopularVacancies-button-next"></div>
      <div className="PopularVacancies-left-overlay"></div>
      <div className="PopularVacancies-right-overlay"></div> 
      <Swiper
        slidesPerView={2}
        // centeredSlides
        navigation={{
          prevEl: ".PopularVacancies-button-prev",
          nextEl: ".PopularVacancies-button-next",
        }}
        breakpoints={{
          320: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }}
      >
        {vacancies.map((el, i) => {
          return (
            <SwiperSlide>
              <Link to={`vacancies/vacancy${el.id}`}>
                <div className="PopularVacancies-slide">
                  <div className="PopularVacancies-slide__top">
                    <img
                      className="PopularVacancies-slide__logo"
                      src={el.company.logo}
                    />
                  </div>
                  <div className="PopularVacancies-slide__vacancy">{el.name}</div>
                  {el.employment.map((e, i) => (
                    <div className="PopularVacancies-slide__employment">
                      {e.name}
                    </div>
                  ))}
                  <div
                    className="PopularVacancies-slide__preview"
                    dangerouslySetInnerHTML={{ __html: el.preview }}
                  ></div>
                  {el.experience.map((e, i) => (
                    <div className="PopularVacancies-slide__experience">
                      {e.name}
                    </div>
                  ))}
                </div>
              </Link>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}

export default PopularVacancies;



// WEBPACK FOOTER //
// ./src/components/PopularVacancies/index.js